var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7776 7.55556C15.7776 9.51924 14.1857 11.1111 12.2221 11.1111C10.2584 11.1111 8.6665 9.51924 8.6665 7.55556C8.6665 5.59188 10.2584 4 12.2221 4C14.1857 4 15.7776 5.59188 15.7776 7.55556Z",
    stroke: "#6929E2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 13.7773H10.4444C7.98985 13.7773 6 15.7672 6 18.2218C6 19.2037 6.79594 19.9996 7.77778 19.9996H16.6667C17.6485 19.9996 18.4444 19.2037 18.4444 18.2218C18.4444 15.7672 16.4546 13.7773 14 13.7773Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIc);
export default __webpack_public_path__ + "static/media/customer_ic.2ee8ad1bbc5c6ca208b16d292486e571.svg";
export { ForwardRef as ReactComponent };